import i18n from '@/lang/i18n'
import buildIconHeaderTemplate from '@/grid/buildIconHeaderTemplate'
import { AgGridColumnType, AgGridExportType, ExportedColDef, ExportedColGroupDef } from '@/shared/models/ag-grid.model'
import { CellClickedEvent, ColDef, ValueGetterParams } from '@ag-grid-enterprise/all-modules'
import { ICellRendererParams } from '@ag-grid-community/core/dist/cjs/rendering/cellRenderers/iCellRenderer'

export const commonIncidentModalGridColumnDefs: (onAttachmentsClicked: (event: CellClickedEvent) => void) => (ColDef | ExportedColDef | ExportedColGroupDef)[] =
    (onAttachmentsClicked) => ([
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            headerName: i18n.tc('incidents.grid.incidentLabel'),
            field: 'incLabel',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 160,
            flex: 1
        },
        {
            headerName: i18n.tc('incidents.grid.incidentDate'),
            field: 'incidentDate',
            type: AgGridColumnType.DATETIME,
            exportType: AgGridExportType.DATETIME,
            minWidth: 160,
            flex: 1
        },
        {
            headerName: i18n.tc('incidents.grid.incidentOrigin'),
            field: 'incidentOrigin.id',
            type: 'incidentOrigin',
            exportField: 'incidentOrigin.name',
            exportType: AgGridExportType.TEXT,
            minWidth: 160,
            flex: 1
        },
        {
            headerName: i18n.tc('incidents.grid.attachments'),
            headerTooltip: i18n.tc('incidents.grid.attachments'),
            headerComponentParams: {
                template: buildIconHeaderTemplate('far fa-paperclip')
            },
            field: 'attachments.length',
            type: AgGridColumnType.ATTACHMENT_COUNT,
            exportField: 'attachments',
            exportType: AgGridExportType.INTEGER,
            onCellClicked: onAttachmentsClicked
        },
        {
            headerName: i18n.tc('incidents.grid.incidentType'),
            field: 'incidentType.id',
            type: 'incidentType',
            exportField: 'incidentType.name',
            exportType: AgGridExportType.TEXT,
            minWidth: 260,
            flex: 1
        },
        {
            headerName: i18n.tc('incidents.grid.severity'),
            colId: 'incidentSeverity.id',
            field: 'incidentSeverity',
            type: AgGridColumnType.INCIDENT_SEVERITY,
            exportField: 'incidentSeverity.name',
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            flex: 1
        },
        {
            headerName: i18n.tc('incidents.grid.entity'),
            type: AgGridColumnType.INCIDENT_CORE_ENTITY,
            field: 'coreEntity',
            exportField: 'coreEntity.translatedName',
            exportType: AgGridExportType.TEXT,
            minWidth: 110,
            flex: 1
        },
        {
            headerName: i18n.tc('diagnosis.grid.caseGrid.labName'),
            field: 'laboratory.labName',
            type: AgGridColumnType.LABORATORIES,
            exportType: AgGridExportType.TEXT,
            minWidth: 200,
            flex: 1
        },
        {
            headerName: i18n.tc('incidents.grid.notified'),
            colId: 'notifiedPersonnelList.id',
            valueGetter: ({ data }: ValueGetterParams) =>
                data.notifiedPersonnelList.map((personnelMember: any) => personnelMember.id),
            cellRenderer: ({ data }: ICellRendererParams) => {
                let value = ''
                if (data?.notifiedPersonnelList) {
                    for (const notifiedPersonnel of data.notifiedPersonnelList) {
                        value += `${notifiedPersonnel.fullName}<br/>`
                    }
                }
                return value
            },
            suppressSorting: false,
            filter: false,
            hide: false,
            minWidth: 170,
            flex: 1
        },
        {
            headerName: i18n.tc('incidents.grid.openingDate'),
            field: 'openingDate',
            type: AgGridColumnType.DATETIME,
            exportType: AgGridExportType.DATETIME,
            minWidth: 160,
            flex: 1
        },
        {
            headerName: i18n.tc('incidents.grid.openedBy'),
            field: 'openedBy.fullName',
            type: AgGridExportType.TEXT,
            exportType: AgGridExportType.TEXT,
            suppressSorting: false,
            filter: false,
            minWidth: 180,
            flex: 1
        },
        {
            headerName: i18n.tc('incidents.grid.closingDate'),
            field: 'closingDate',
            type: AgGridColumnType.DATETIME,
            exportType: AgGridExportType.DATETIME,
            minWidth: 160,
            flex: 1
        },
        {
            headerName: i18n.tc('incidents.grid.closedBy'),
            field: 'closedBy.fullName',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            suppressSorting: false,
            filter: false,
            minWidth: 180,
            flex: 1
        },
        {
            headerName: i18n.tc('incidents.grid.visualizationDate'),
            type: AgGridColumnType.TEXT,
            field: '',
            minWidth: 160,
            flex: 1
        }
    ])
